import React, { useEffect, useState, useMemo } from 'react';
import { Icon, Row, Col, Collapse, Button, Tooltip, Modal, Alert, Divider } from 'antd';
import {
  getDisplayDiscounts,
  getSimilarAspectRatio,
  getMultiplyByStatus
} from '../../../../../services/display';
import ScreensGroupHolder from '../../styles/screensGroupStyle';
import { Trans, useTranslation } from 'react-i18next';
import Slider from 'react-slick';
//Revisar
import {
  hasAccessRole,
  calculeDaysOfCampaign,
  calculeValuesPerGroup,
  SeparateNumberFormat,
  validateIntegerInput,
  getDomain,
  isCpmiCompany
} from '../../../../../services/utils';
import UserRoleEnum from '../../../../../constants/UserRoleEnum';
import { getCpmByStatusCampaign } from '../../../../../services/display';
import NumberFormat from '../../../../shared/components/NumberFormat';
import { getRelationShowDays } from '../../../../../services/display';
import {
  getSpotsPerDay,
  getBonusSpotsPerDay,
  getImpressionsPerDay,
  getCpmByStatusCampaign as getCpmByStatus
} from '../../../../../services/display';
import ScreenContainer from '../../../../shared/containers/ScreenContainer';
import PendingContentButton from '../../../../shared/components/PendingContentButton';
import HelpTooltipIcon, { HelpIcon } from '../../../../shared/components/HelpTooltipIcon';
import LazyRender from '../../../../shared/components/LazyRender';
import RulesContainer from '../../../../shared/containers/RulesContainer';
import ListRulesComponent from './ListRulesComponent';
import RelationSliderComponent from './RelationSliderComponent';
import AudienceImpactsComponent from './AudienceImpactsComponent';
import ContentSpecificationAlertComponent from './supporting/ContentSpecificationAlertComponent';
import ScreenLibraryModalContainer from '../../containers/step2_settings/ScreenLibraryModalContainer';
import DiscountProgressBar from './DiscountProgressBar';
import TotalInvestmentComponent from './TotalInvestmentComponent';
import DisplayGroupHeader from './DisplayGroupHeader';
import Text from 'antd/lib/typography/Text';
import Colors from '../../../../../themes/Colors';
import { checkIsNewDisplayInEdit } from '../../../../../services/campaignManager';
import NewScreenTag from '../../../../shared/components/NewScreenTag';
import SubsidizeButton from '../../../../shared/components/SubsidizeButton';
import SubsidizedStatusTag from '../../../../shared/components/SubsidizedStatusTag';
import { impressions } from '../../services/investmentCalculations';

const { Panel } = Collapse;

const domain = getDomain(window.location.hostname);
const ScreensGroupComponent = props => {
  const { t } = useTranslation();

  const {
    user,
    toggleFillScreen,
    customContents,
    audience,
    loadingAudience,
    toleranceResolution,
    editCampaignActive,
    updateImpressionsDisplay,
    currentCampaign,
    managerDisplayFilter,
    disabledManagerDisplayFilter,
    disableManagerDisplayFilter,
    displaysCollection,
    reportSingleData,
    cart,
    date_from,
    date_to,
    programmatic,
    updateContentName,
    updateListOfContentsInCampaign,
    loadingSingleReport,
    currency,
    campaignCurrency,
    applyRelationOnScreens,
    allDisplaysAreOwn,
    updateSubsidizedPrice,
    removeRelationsOnCampaign,
    audienceHoursOfDay,
    audienceDaysOfWeek,
    audienceQualitative,
    getAudienceHoursOfDayRequest,
    getAudienceDaysOfWeekRequest,
    getAudienceQualitativeRequest,
    isPaymentStatusApproved,
    setActive,
    setIsCampaignPaused,
    updatePromisedShowsSubsidized,
    removeDisplayFromCart,
    removeDisplayOnCampaign,
    updateCustomContents,
    displays,
    enabledRenderRules,
    creationType,
    togglePendingContent,
    parentGroupInvestment,
    handleChangeGroupProposal,
    managerDisplaySelector,
    toggleSecuredInvestment,
    initialBackup,
    hasInitialBackup,
    isSuperUser,
  } = props;

  // Modal width
  const modalWidth =
    window.innerWidth > 1200 ? 1200 : window.innerWidth > 992 ? 900 : window.innerWidth;
  const usedCurrency = editCampaignActive ? campaignCurrency : currency;
  const [selectDisplayForRules, setSelectDisplayForRules] = useState(null);
  const [selectGroupDisplayRules, setSelectGroupDisplayRules] = useState(null);
  const [relationToDelete, setRelationToDelete] = useState(null);
  const [displaysGroups, setDisplaysGroups] = useState([]);
  const [showScreenDetail, setShowScreenDetail] = useState(false);
  const [displayModalInfo, setDisplayModalInfo] = useState(null);
  const [displayModalUpdateContent, setDisplayModalUpdateContent] = useState(null);
  const [indexGroup, setIndexGroup] = useState(null);

  const filteredContentsByDisplay = useMemo(() => {
    const result = {};
    customContents.forEach(item => {
      if (!result[item.displayId]) {
        result[item.displayId] = [];
      }
      result[item.displayId].push(item);
    });
    return result;
  }, [customContents]);

  const customPanelStyleContent = {
    borderTopWidth: '0px',
    borderLeftWidth: '0px',
    borderRightWidth: '0px'
  };

  const displayMap = new Map(displaysCollection.map(display => [display.id, display.cpmi]));

  const getAvgCPM = contentsDisplay => {
    if (!contentsDisplay.length || !displayMap.size) return 0;
    let totalCPM = 0;
    let totalCount = 0;
    contentsDisplay.forEach(({ displayId }) => {
      const cpmi = displayMap.get(displayId);
      if (cpmi !== undefined) {
        totalCPM += cpmi;
        totalCount++;
      }
    });
    return totalCount ? totalCPM / totalCount : 0;
  };

  const groupByDimension = () => {
    const groups = [];
    displaysCollection.forEach(display => {
      const indice = getSimilarAspectRatio(display.resolution_width, display.resolution_height, t);
      const groupIndex = groups.findIndex(item => item.key === indice);
      display = {
        ...display,
        fill_screen: customContents.some(
          item => item.displayId === display.id && item.fill_screen === 1
        )
          ? 1
          : 0
      };
      if (groupIndex === -1) {
        groups.push({ key: indice, displays: [display] });
      } else {
        groups[groupIndex].displays.push(display);
      }
    });
    return groups;
  };

  // Toggle fill screen for multiple relations for this display
  const groupToggleFillScreen = ({ key, displays, fill_screen }) => {
    let newFillScreen = fill_screen === 1 ? 0 : 1; // change status of fill screen
    displays.forEach(screen => {
      toggleFillScreen(screen.id, screen.relationId, newFillScreen, 'multiple');
    });
    let newStateGroup = displaysGroups.map(group => {
      if (key === group.key) {
        return { ...group, fill_screen: newFillScreen };
      }
      return group; // Added return statement for unchanged groups
    });
    setDisplaysGroups([...newStateGroup]);
  };

  // Toggle fill screen for a single relation for this display
  const displayToggleFillScreen = display => {
    let newFillScreen = customContents.some(
      item => item.displayId === display.id && item.fill_screen === 1
    )
      ? 0
      : 1;
    setDisplaysGroups(
      displaysGroups.map(group => {
        if (group.displays.find(item => item.id === display.id)) {
          // if not exist fill_screen in display, set 1 because is the first time
          let newFillScreen =
            display.fill_screen === undefined ? 1 : display.fill_screen === 1 ? 0 : 1;
          return {
            ...group,
            displays: group.displays.map(d =>
              d.id === display.id ? { ...d, fill_screen: newFillScreen } : d
            )
          };
        }
        return group;
      })
    );
    toggleFillScreen(display.id, null, newFillScreen, 'multiple');
  };

  // Toggle fill screen for a single relation for this display
  const displayTogglePendingContent = display => {
    let newIsPendingContent = customContents.some(
      item => item.displayId === display.id && item.isPendingContent === true
    )
      ? false
      : true;
    setDisplaysGroups(
      displaysGroups.map(group => {
        if (group.displays.find(item => item.id === display.id)) {
          // if not exist fill_screen in display, set 1 because is the first time
          let newIsPendingContent =
            display.isPendingContent === undefined
              ? true
              : display.isPendingContent === true
              ? false
              : true;
          return {
            ...group,
            displays: group.displays.map(d =>
              d.id === display.id ? { ...d, isPendingContent: newIsPendingContent } : d
            )
          };
        }
        return group;
      })
    );
    togglePendingContent(display.id, null, newIsPendingContent, 'multiple');
  };

  const fixedBudgetInDisplay = (displays, isFixedBudgetDisplay) => {
    const displayIds = displays.map(display => display.id);
    const auxcustomContentsAux = customContents.map(item => {
      if (displayIds.includes(item.displayId)) {
        return {
          ...item,
          isFixedBudget: !isFixedBudgetDisplay
        };
      }
      return item;
    });
    updateCustomContents(auxcustomContentsAux);
  };

  const getTooltipForFixedBudget = (type, status) => {
    let typeAux = t('this spot');
    typeAux = type === 'display' ? t('this display') : typeAux;
    typeAux = type === 'groupDisplay' ? t('this displays group') : typeAux;
    let tooltip = '';
    if (!status) {
      tooltip = t(
        'When setting the amount for (n_type), it will not be modified during the automatic budget redistribution. It can be adjusted manually at any time.',
        { n_type: typeAux }
      );
    } else {
      tooltip = t(
        'If the amount for (n_type) is not fixed, it may be modified during the automatic budget redistribution. It can also be adjusted manually at any time.',
        { n_type: typeAux }
      );
    }
    return tooltip;
  };

  const getContentDisplayByScreenGroup = displaysGroup => {
    let listContentDisplay = [];
    displaysGroup.map(screen => {
      let customContent = customContents.filter(item => item.displayId === screen.id);
      listContentDisplay = [...listContentDisplay, ...customContent];
    });
    return listContentDisplay;
  };

  const stopPropagation = event => {
    event.stopPropagation();
  };

  const handleShowScreenDetail = (defaultTabScreenDetail, display = null) => {
    if (defaultTabScreenDetail === 'close') {
      setDisplayModalInfo(null);
      setShowScreenDetail(!showScreenDetail);
      return;
    }
    setDisplayModalInfo(display);
    setShowScreenDetail(!showScreenDetail);
  };

  const handleModalUpdateContent = display => {
    setDisplayModalUpdateContent(display);
    if (!display) {
      setDisplayModalUpdateContent(null);
      return;
    }
    setDisplayModalUpdateContent(display);
  };

  const durationCampaign = calculeDaysOfCampaign(date_from, date_to);

  const calculateTotalShows = contentsDisplay => {
    return contentsDisplay.reduce((total, relation) => {
      if (reportSingleData && reportSingleData.report) {
        const foundElement = reportSingleData.report.find(
          element =>
            element.display === relation.displayId && element.content === relation.content.id
        );
        if (foundElement) {
          total += relation.promised_shows - foundElement.shows;
        } else {
          total += relation.promised_shows;
        }
      } else {
        total += relation.promised_shows;
      }
      return total;
    }, 0);
  };

  const spotsPerDate = contentsDisplay => {
    const promiseShowPerDay = contentsDisplay.reduce((total, relation) => {
      const impressionWithRules = getRelationShowDays(date_from, date_to, relation.rules);
      const promisedShowsWithRules =
        impressionWithRules === 0 ? 0 : relation.promised_shows / impressionWithRules;
      total += promisedShowsWithRules;
      return total;
    }, 0);
    return Math.round(promiseShowPerDay);
  };

  const getSpotStatesInGroup = (contentsDisplay, t) => {
    const states = new Set();
    contentsDisplay.forEach(relation => {
      const contentDisplay = currentCampaign.contents_displays.find(
        cd =>
          cd.id === relation.relationId &&
          cd.display_id === relation.displayId &&
          cd.content_id === relation.content.id
      );
      if (!contentDisplay) return;
      let revisionStatus;
      if (contentDisplay.revision_status) {
        revisionStatus = contentDisplay.revision_status;
      }
      const isActive = relation.active;
      const pendingContent = false;
      if (revisionStatus === 'approved' && !pendingContent && isActive === 1) {
        states.add(t('Spot Approved'));
      } else if (isActive === 0) {
        states.add(t('Inactive'));
      } else if (revisionStatus === 'rejected' && !pendingContent) {
        states.add(t('Spot Rejected'));
      } else if (revisionStatus === 'pending' || pendingContent) {
        states.add(t('The owner of this screen has not yet approved'));
      } else {
      }
    });
    const result = Array.from(states);
    return result;
  };

  const handlePromisedShowsChange = (value, contents) => {
    const parseValue = validateIntegerInput(value);
    if (parseValue === null) {
      return;
    }
    const totalShows = contents.reduce((acc, content) => acc + content.promised_shows, 0);
    if (totalShows === 0) {
      // If there are no shows, distribute the new value equally among contents
      if (contents.length > 0) {
        const showsPerContent = Math.floor(parseValue / contents.length);
        const remainder = parseValue % contents.length;
        contents.forEach((content, index) => {
          const newPromisedShows = showsPerContent + (index < remainder ? 1 : 0);
          updateImpressionsDisplay(content.displayId, content.relationId, newPromisedShows);
        });
      }
      return;
    }
    // Proportional distribution
    contents.forEach(content => {
      const proportion = content.promised_shows / totalShows;
      const newPromisedShows = Math.round(parseValue * proportion);
      updateImpressionsDisplay(content.displayId, content.relationId, newPromisedShows);
    });
  };

  // Remove and update impressions of campaign
  const removeRelationFromDisplayView = relationToDelete => {
    const { typeDelete, displayId, relationId } = relationToDelete;
    // Remove the display from the cart and the relation
    if (typeDelete === 'deleteDisplay') {
      removeDisplayFromCart(displayId);
      removeDisplayOnCampaign(displayId);
    }
    // Remove the display from the displaysCollection and the relation
    if (typeDelete === 'deleteGroupDisplays') {
      displayId.forEach(display => {
        removeDisplayFromCart(display.id);
        removeDisplayOnCampaign(display.displayId);
      });
    }
    if (typeDelete === 'deleteRelation') {
      // Remove the relation from the display
      let contentDisplayForDelete = customContents.find(item => item.relationId === relationId);
      let contentDisplayForUpdateImpression = customContents.filter(
        item => item.displayId === displayId
      );
      removeRelationsOnCampaign(displayId, contentDisplayForDelete.content.id);
      let countCustomesContent = 0;
      countCustomesContent = customContents.filter(
        customContent => customContent.displayId === displayId
      ).length;
      countCustomesContent = countCustomesContent - 1;
      let impressions = Math.trunc(contentDisplayForDelete.promised_shows / countCustomesContent);
      // if (editCampaignActive && currentCampaign.payment_status === 'approved') {
      // // updateImpressions(customContents, false);
      // } else {
      contentDisplayForUpdateImpression.forEach(item => {
        let newPromisedShows = item.promised_shows + impressions;
        updateImpressionsDisplay(item.displayId, item.relationId, newPromisedShows);
      });
      // }
    }
    showModalDeleteRelation();
    return;
  };

  // Variable to show the modal of the display when applying rules
  const showModalDisplayRules = (display = null) => {
    setSelectDisplayForRules(display ? display.id : null);
  };

  const fixedBudget = customContentUpdate => {
    const customContentsAux = customContents.map(customContent => {
      if (customContent.relationId === customContentUpdate.relationId) {
        return { ...customContent, isFixedBudget: !customContentUpdate.isFixedBudget };
      }
      return customContent;
    });
    updateCustomContents(customContentsAux);
  };

  // Variable to show the modal of the group of displays when applying rules
  const showModalGroupDisplayRules = (indice = null) => {
    setSelectGroupDisplayRules(indice ? indice : null);
  };

  const showModalDeleteRelation = (typeDelete = null, displayId = null, relationId = null) => {
    if (!typeDelete) {
      setRelationToDelete(null);
      return;
    }
    let title = '';
    let description = '';
    if (typeDelete === 'deleteRelation') {
      title = t('Remove screen from campaign');
      description = t(
        `The ad will be removed from the screen, and the spots will be redistributed among the other versions. You can add it again from the previous Ads step or by clicking the Add Ad button.${isCpmiCompany(user) ? '_cpmi' : ''}`
      );
    }
    if (typeDelete === 'deleteDisplay') {
      title = t('Remove screen from campaign');
      description = t('You are going to remove this screen from the campaign');
    }
    if (typeDelete === 'deleteGroupDisplays') {
      title = t('Remove group of screens');
      description = t(
        'By removing the group, all screens within this group will be removed from the campaign.'
      );
    }
    setRelationToDelete({
      typeDelete,
      displayId,
      relationId,
      title,
      description
    });
  };

  const getAspectRatio = (width, height) => {
    const gcd = (a, b) => {
      if (b === 0) return a || 1;
      if (!a || isNaN(a) || isNaN(b)) return 1;
      return gcd(b, a % b);
    };
    const divisor = gcd(width, height);
    if (!divisor || divisor === 0) return `${width}:${height}`;
    return `${width / divisor}:${height / divisor}`;
  };

  const getApproximateAspectRatio = (width, height) => {
    const tolerance = 0.5;
    const aspect = width / height;
    const roundedAspect = Math.round(aspect / tolerance) * tolerance;
    return roundedAspect.toFixed(2);
  };

  const setGroupReduce = (acc, display, filter) => {
    if (!acc || !display || !filter) return [];
    if (!acc[filter]) {
      acc[filter] = { key: filter, displays: [] };
    }
    acc[filter].displays.push(display);
    return acc;
  };

  const groupByAspectRatio = () => {
    return Object.values(
      displaysCollection.reduce((acc, display) => {
        const aspectRatio = getAspectRatio(display.resolution_width, display.resolution_height);
        const approximateAspectRatio = getApproximateAspectRatio(
          display.resolution_width,
          display.resolution_height
        );
        if (!acc[approximateAspectRatio]) {
          acc[approximateAspectRatio] = {
            key: aspectRatio,
            displays: []
          };
        }
        acc[approximateAspectRatio].displays.push(display);
        return acc;
      }, {})
    );
  };

  const groupByResolution = () => {
    return Object.values(
      displaysCollection.reduce((acc, display) => {
        const resolution = `${display.resolution_width}x${display.resolution_height}`;
        return setGroupReduce(acc, display, resolution);
      }, {})
    );
  };

  const groupByLocationType = () => {
    return Object.values(
      displaysCollection.reduce((acc, display) => {
        const locationType = display.location_type;
        return setGroupReduce(acc, display, locationType);
      }, {})
    );
  };

  const groupBySubType = () => {
    return Object.values(
      displaysCollection.reduce((acc, display) => {
        const name_type = display.open_ooh_venue_type_id
          ? `subtype_${display.open_ooh_venue_type_id}`
          : 'Not assigned';
        const subtype = t(name_type);
        return setGroupReduce(acc, display, subtype);
      }, {})
    );
  };

  const ungroup = () => [
    {
      displays: displaysCollection,
      key: 'none'
    }
  ];

  const updateSubsidizedPriceDisplay = (displayId, checked) => {
    updateSubsidizedPrice(displayId, checked, 'display');
  };

  function getListContentsCompatible(display) {
    return Object.keys(display.format_settings)
      .filter(format => display.format_settings[format])
      .map(format => {
        switch (format) {
          case 'image':
            return t('Image');
          case 'video':
            return t('Video');
          case 'html':
            return t('HTML');
          default:
            return format.charAt(0).toUpperCase() + format.slice(1);
        }
      })
      .join(' - ');
  }

  const groupAccordingToFilter = () => {
    let oldDisplaysGroups = displaysGroups;
    let displaysGroupAux;
    if (managerDisplayFilter === 'aspect') displaysGroupAux = groupByAspectRatio();
    if (managerDisplayFilter === 'dimensions') displaysGroupAux = groupByDimension();
    if (managerDisplayFilter === 'resolution') displaysGroupAux = groupByResolution();
    if (managerDisplayFilter === 'screen') displaysGroupAux = groupByLocationType();
    if (managerDisplayFilter === 'subtype') displaysGroupAux = groupBySubType();
    if (managerDisplayFilter === 'none') displaysGroupAux = ungroup();
    // Defined the fill screen for the group of displays
    if (displaysGroupAux[0] && displaysGroupAux[0].fill_screen === undefined) {
      displaysGroupAux = displaysGroupAux.map(item => {
        let groupItem = oldDisplaysGroups.find(oldItem => oldItem.key === item.key);
        return {
          ...item,
          fill_screen: groupItem ? groupItem.fill_screen : 0
        };
      });
    }
    setDisplaysGroups(displaysGroupAux);
    disableManagerDisplayFilter(false);
  };

  const handleIsPausedToggle = (isCampaignPaused, display) => {
    const active = isCampaignPaused ? 1 : 0;
    const customContentsDisplay = customContents.filter(
      customContent => customContent.displayId === display.id
    );
    customContentsDisplay.forEach(item => {
      setActive(item.relationId, active);
    });
  };

  const displayIsPaused = display => {
    const customContentsDisplay = customContents.filter(
      customContent => customContent.displayId === display.id
    );
    const isPaused = customContentsDisplay.every(item => item.active === 0);
    return isPaused;
  };

  useEffect(() => {
    groupAccordingToFilter();
  }, [cart, managerDisplayFilter, displaysCollection]);

  return (
    <ScreensGroupHolder>
      <Row type="flex" className="screens-group">
        {!disabledManagerDisplayFilter &&
          displaysGroups.map((group, index) => {
            const { key, displays } = group;
            // search the custom contents for the displays of the group
            let contentsDisplay = customContents.filter(item =>
              displays.some(display => display.id === item.displayId)
            );
            let investmentGroup, impactsGroup;
            const option = editCampaignActive
              ? { currentCampaign: currentCampaign, calculateImpacts: true, editCampaignActive }
              : { calculateImpacts: true, editCampaignActive };
            [investmentGroup, impactsGroup] = calculeValuesPerGroup(
              group,
              contentsDisplay,
              audience,
              option
            );
            return (
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                className="appear-animation customPanelStyleDisplays"
                key={group.key}
              >
                <Collapse
                  style={customPanelStyleContent}
                  defaultActiveKey={['none']}
                  className={group.key === 'none' ? 'collapseWitthoutHeader' : ''}
                >
                  <Panel
                    header={
                      group.key === 'none' ? null : (
                        <DisplayGroupHeader
                          groupDisplay={group}
                          index={index}
                          contentsDisplay={contentsDisplay}
                          investmentGroup={investmentGroup}
                          programmatic={programmatic}
                          enabledRenderRules={enabledRenderRules}
                          isPaymentStatusApproved={isPaymentStatusApproved}
                          creationType={creationType}
                          editCampaignActive={editCampaignActive}
                          currentCampaign={currentCampaign}
                          stopPropagation={stopPropagation}
                          showModalGroupDisplayRules={showModalGroupDisplayRules}
                          groupToggleFillScreen={groupToggleFillScreen}
                          setIndexGroup={setIndexGroup}
                          showModalDeleteRelation={showModalDeleteRelation}
                          fixedBudgetInDisplay={fixedBudgetInDisplay}
                          handleChangeGroupProposal={handleChangeGroupProposal}
                          updateImpressionsDisplay={updateImpressionsDisplay}
                          date_from={date_from}
                          date_to={date_to}
                          displaysGroups={displaysGroups}
                          currency={currency}
                          campaignCurrency={campaignCurrency}
                          audience={audience}
                          audienceHoursOfDay={audienceHoursOfDay}
                          audienceDaysOfWeek={audienceDaysOfWeek}
                          getAudienceHoursOfDayRequest={getAudienceHoursOfDayRequest}
                          getAudienceDaysOfWeekRequest={getAudienceDaysOfWeekRequest}
                          getTooltipForFixedBudget={getTooltipForFixedBudget}
                          getContentDisplayByScreenGroup={getContentDisplayByScreenGroup}
                          getAvgCPM={getAvgCPM}
                          parentGroupInvestment={parentGroupInvestment}
                          toggleSecuredInvestment={toggleSecuredInvestment}
                          managerDisplaySelector={managerDisplaySelector}
                          initialBackup={initialBackup}
                          hasInitialBackup={hasInitialBackup}
                          isSuperUser={isSuperUser}
                        />
                      )
                    }
                    key={group.key}
                  >
                    <div className="horizontal-line"></div>
                    {group.displays.map(display => {
                      const customContentsFiltered = customContents.filter(
                        item => item.displayId === display.id
                      );
                      const listContentsCompatible = getListContentsCompatible(display);
                      const isFixedBudgetDisplay = customContentsFiltered.every(
                        item => item.isFixedBudget === true
                      );
                      const isPendingContentDisplay = customContentsFiltered.some(
                        item => item.isPendingContent === true
                      );
                      const totalSpotsPerDay = customContentsFiltered.reduce((total, relation) => {
                        const spotsPerDay = getSpotsPerDay(relation, date_from, date_to);
                        return total + spotsPerDay;
                      }, 0);
                      const multiplier = getMultiplyByStatus(
                        editCampaignActive,
                        currentCampaign,
                        display
                      );
                      const totalImpressionsPerDay = customContentsFiltered.reduce(
                        (total, relation) =>
                          total + getImpressionsPerDay(relation, date_from, date_to, multiplier),
                        0
                      );
                      // Real campaign total (sum of promised_shows) — used for "total"
                      // discount thresholds (avoids the rounding inflation of spd * days)
                      const totalPromisedShows = customContentsFiltered.reduce(
                        (total, relation) => total + (relation.promised_shows || 0),
                        0
                      );
                      const originalCpm = getCpmByStatus(
                        editCampaignActive,
                        currentCampaign,
                        display
                      );
                      // Calculate bonus using display-level total spots (not per relation)
                      const firstRelation = customContentsFiltered[0];
                      // Calculate campaign days for total spots calculation
                      const campaignDays = firstRelation
                        ? getRelationShowDays(date_from, date_to, firstRelation.rules)
                        : 0;
                      const totalBonusSpotsPerDay = firstRelation
                        ? getBonusSpotsPerDay(
                            display,
                            firstRelation,
                            date_from,
                            date_to,
                            originalCpm,
                            totalSpotsPerDay,
                            totalPromisedShows
                          )
                        : 0;
                      // Bonus impressions are folded into the daily figure instead of
                      // being shown as a separate chip.
                      const totalImpressionsPerDayWithBonus =
                        totalImpressionsPerDay +
                        (isPaymentStatusApproved
                          ? 0
                          : impressions.fromSpots(totalBonusSpotsPerDay, multiplier));
                      const hasDiscounts =
                        display.extra_info_programmatic_prices &&
                        display.extra_info_programmatic_prices.programmatic_volume_discounts &&
                        display.extra_info_programmatic_prices.programmatic_volume_discounts
                          .length > 0;
                      const isSubsidizedDisplay = customContentsFiltered.every(
                        item => item.subsidized_price
                      );
                      const isDisplaySecured =
                        customContentsFiltered.length > 0 &&
                        customContentsFiltered.every(c => c.is_secured_investment);
                      const totalSpots = totalSpotsPerDay * campaignDays;
                      // Get minimum programmatic spots configuration
                      const displayMinimumProgrammaticSpotsDaily =
                        display.minimum_programmatic_spots;
                      const displayMinimumProgrammaticPeriod = display.minimum_programmatic_period;
                      // Calculate minimum spots based on period type
                      let minumumSpotsPeriod;
                      let minimumProgrammaticSpotsDaily;
                      let minimumProgrammaticSpotsTotal;
                      // If minimum_programmatic_period is 0: minimum_programmatic_spots is a daily value
                      if (displayMinimumProgrammaticPeriod === 0) {
                        // Daily minimum: spots per day
                        minimumProgrammaticSpotsDaily = displayMinimumProgrammaticSpotsDaily;
                        minimumProgrammaticSpotsTotal =
                          displayMinimumProgrammaticSpotsDaily * campaignDays;
                      } else {
                        // If minimum_programmatic_period > 0: minimum_programmatic_spots is for the total period
                        // Period minimum: total spots divided by campaign days
                        minumumSpotsPeriod =
                          displayMinimumProgrammaticSpotsDaily * displayMinimumProgrammaticPeriod;
                        minimumProgrammaticSpotsTotal = minumumSpotsPeriod;
                        minimumProgrammaticSpotsDaily =
                          campaignDays > 0 ? Math.ceil(minumumSpotsPeriod / campaignDays) : 0;
                      }
                      // $$$
                      const minimumInvestmentDaily =
                        minimumProgrammaticSpotsDaily * (originalCpm / 1000);
                      const minimumInvestmentTotal = minimumInvestmentDaily * campaignDays;

                      const isNewDisplay = editCampaignActive && checkIsNewDisplayInEdit(display.id, initialBackup, hasInitialBackup);
                      return (
                        <div className="displayRow" key={display.id}>
                          {/* >= 992px: info | anuncios | acciones en una fila.
                              < 992px: apilados a ancho completo. */}
                          <Row key={display.id} type="flex">
                            <Col
                              xs={24}
                              sm={24}
                              md={24}
                              lg={4}
                              xl={4}
                              className="displayInfoCol"
                            >
                              <div>
                                <div
                                  className="textGroup displayName"
                                  style={{ marginBottom: '10px', textAlign: 'center' }}
                                >
                                  <Tooltip placement="top" title={t('Screen detail')}>
                                    <Button
                                      shape="circle"
                                      className="buttonActionsDisplayGroup"
                                      onClick={() => handleShowScreenDetail('info', display)}
                                      size="small"
                                    >
                                      <Icon type="info-circle" theme="outlined" />
                                    </Button>
                                  </Tooltip>
                                  <span>{display.name}</span>
                                </div>
                                {isNewDisplay && isPaymentStatusApproved && (
                                  <div style={{ marginBottom: '6px', textAlign: 'center' }}>
                                    <NewScreenTag />
                                  </div>
                                )}
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                  <div style={{ textAlign: 'center' }}>
                                    <ContentSpecificationAlertComponent
                                      displays={[display]}
                                      customContentsFiltered={customContentsFiltered}
                                    />
                                  </div>
                                  {selectDisplayForRules === display.id && (
                                    <Modal
                                      key={display.id}
                                      title={t('Rules in display')}
                                      visible={selectDisplayForRules === display.id}
                                      footer={[
                                        <Button
                                          key="ok"
                                          type="primary"
                                          onClick={() => showModalDisplayRules()}
                                        >
                                          {t('Close')}
                                        </Button>
                                      ]}
                                      onCancel={() => showModalDisplayRules()}
                                      width={800}
                                    >
                                      <RulesContainer
                                        key={display.id}
                                        workingHours={display.working_hours}
                                        typeModal="display"
                                        typeName={display.name}
                                        listContentDisplay={customContentsFiltered}
                                      />
                                    </Modal>
                                  )}
                                  <div className="tagsContainer">
                                    {listContentsCompatible.split(' - ').map((format, index) => (
                                      <div key={index} className="compatibleContent">
                                        <Icon
                                          style={{ fontSize: '15px', marginRight: '5px' }}
                                          type={
                                            format === t('Image')
                                              ? 'picture'
                                              : format === t('Video')
                                              ? 'play-circle'
                                              : format === t('HTML')
                                              ? 'code'
                                              : 'file'
                                          }
                                        />
                                        {format}
                                      </div>
                                    ))}
                                    <div className="compatibleContent">
                                      Px {display.resolution_width}x{display.resolution_height}
                                    </div>
                                    <Tooltip placement="top" title={t('Screen space time')}>
                                      <div className="compatibleContent">
                                        <Icon
                                          style={{ fontSize: '15px', marginRight: '5px' }}
                                          type="clock-circle"
                                        />
                                        {display.slot_length / 1000} {t('secs')}
                                      </div>
                                    </Tooltip>
                                  </div>
                                  {enabledRenderRules && (
                                    <div
                                      style={{
                                        textAlign: 'center',
                                        marginTop: '10px',
                                        marginBottom: '10px'
                                      }}
                                    >
                                      <ListRulesComponent
                                        listContentDisplay={customContentsFiltered}
                                        styleRules={{ container: { justifyContent: 'center' } }}
                                        type="display"
                                        defaultText={t('Without rules in display')}
                                        showModalRules={() => showModalDisplayRules(display)}
                                      ></ListRulesComponent>
                                    </div>
                                  )}
                                  {isDisplaySecured && programmatic === 'programmatic' && (
                                    <Tooltip placement="top" title={t('This screen is secured.')}>
                                      <div style={{ textAlign: 'center', marginTop: '8px' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65.5 87.97" style={{ width: '20px', height: '20px' }}>
                                          <path fill="#979696" d="M59.7,31.94c0-14.42-11.69-26.11-26.11-26.11S7.48,17.52,7.48,31.94c0,8.37,3.94,15.81,10.06,20.59l-7.69,24.13,11.65-5.25,7.93,9.27,4.64-21.81,4.64,21.81,8.09-9.12,11.5,5.1-7.88-24.74c5.68-4.79,9.3-11.96,9.3-19.97ZM12.77,31.94c0-11.5,9.32-20.82,20.82-20.82s20.82,9.32,20.82,20.82-9.32,20.82-20.82,20.82-20.82-9.32-20.82-20.82Z"/>
                                          <circle fill="#979696" cx="33.59" cy="31.94" r="12.81"/>
                                        </svg>
                                      </div>
                                    </Tooltip>
                                  )}
                                </div>
                              </div>
                            </Col>
                            <Col
                              xs={24}
                              sm={24}
                              md={24}
                              lg={15}
                              xl={15}
                              className="contentRelation"
                            >
                              <LazyRender>
                                <RelationSliderComponent
                                  audience={audience}
                                  toleranceResolution={toleranceResolution}
                                  loadingAudience={loadingAudience}
                                  display={display}
                                  Slider={Slider}
                                  customContents={customContents}
                                  reportSingleData={reportSingleData}
                                  currentCampaign={currentCampaign}
                                  editCampaignActive={editCampaignActive}
                                  showModalDeleteRelation={showModalDeleteRelation}
                                  toggleFillScreen={toggleFillScreen}
                                  togglePendingContent={togglePendingContent}
                                  date_to={date_to}
                                  date_from={date_from}
                                  programmatic={programmatic}
                                  currency={currency}
                                  campaignCurrency={campaignCurrency}
                                  updateImpressionsDisplay={updateImpressionsDisplay}
                                  updateContentName={updateContentName}
                                  updateListOfContentsInCampaign={updateListOfContentsInCampaign}
                                  loadingSingleReport={loadingSingleReport}
                                  user={user}
                                  allDisplaysAreOwn={allDisplaysAreOwn}
                                  updateSubsidizedPrice={updateSubsidizedPrice}
                                  applyRelationOnScreens={applyRelationOnScreens}
                                  audienceHoursOfDay={audienceHoursOfDay}
                                  audienceDaysOfWeek={audienceDaysOfWeek}
                                  getAudienceHoursOfDayRequest={getAudienceHoursOfDayRequest}
                                  getAudienceDaysOfWeekRequest={getAudienceDaysOfWeekRequest}
                                  cart={cart}
                                  isPaymentStatusApproved={isPaymentStatusApproved}
                                  updatePromisedShowsSubsidized={updatePromisedShowsSubsidized}
                                  cpmDisplay={getCpmByStatusCampaign(
                                    editCampaignActive,
                                    currentCampaign,
                                    display
                                  )}
                                  setIsCampaignPaused={setIsCampaignPaused}
                                  setActive={setActive}
                                  displays={displays}
                                  updateCustomContents={updateCustomContents}
                                  fixedBudget={fixedBudget}
                                  getTooltipForFixedBudget={getTooltipForFixedBudget}
                                  enabledRenderRules={enabledRenderRules}
                                  creationType={creationType}
                                  initialBackup={initialBackup}
                                  hasInitialBackup={hasInitialBackup}
                                />
                              </LazyRender>
                            </Col>
                            <Col
                              xs={24}
                              sm={24}
                              md={24}
                              lg={5}
                              xl={5}
                              className="displayActionsCol"
                            >
                              <div className="displayActionsInner">
                                {/* width 100% because the column centers its children
                                    instead of stretching them, and the Divider needs
                                    the full width to read as a separator. The class
                                    keeps it full width in the compact (<992px) layout,
                                    where the other blocks of this column go in a row. */}
                                <div className="displayActionsTitle" style={{ width: '100%' }}>
                                  <div className="textGroup" style={{ textAlign: 'center' }}>
                                    <Icon
                                      type="desktop"
                                      theme="outlined"
                                      style={{ color: Colors.primaryAccent, marginRight: '5px' }}
                                    />
                                    {t('Screen details')}
                                  </div>
                                  <Divider style={{ margin: '8px 0 12px' }} />
                                </div>
                                <div style={{ textAlign: 'center' }}>
                                  <TotalInvestmentComponent
                                    durationCampaign={durationCampaign}
                                    currentCampaign={currentCampaign}
                                    currency={editCampaignActive ? campaignCurrency : currency}
                                    display={display}
                                    displays={display}
                                    audience={audience}
                                    type="display"
                                    user={user}
                                    editCampaignActive={editCampaignActive}
                                    audienceHoursOfDay={audienceHoursOfDay}
                                    audienceDaysOfWeek={audienceDaysOfWeek}
                                    getAudienceHoursOfDayRequest={getAudienceHoursOfDayRequest}
                                    getAudienceDaysOfWeekRequest={getAudienceDaysOfWeekRequest}
                                    getAudienceQualitativeRequest={getAudienceQualitativeRequest}
                                    audienceQualitative={audienceQualitative}
                                    customContents={customContents}
                                    cpmDisplay={getCpmByStatusCampaign(
                                      editCampaignActive,
                                      currentCampaign,
                                      display
                                    )}
                                    isProgrammatic={programmatic === 'programmatic'}
                                    parentGroupInvestment={investmentGroup}
                                    isFixedBudgetDisplay={isFixedBudgetDisplay}
                                    handleChangeGroupProposal={handleChangeGroupProposal}
                                    isPaymentStatusApproved={isPaymentStatusApproved}
                                    group={group}
                                    date_from={date_from}
                                    date_to={date_to}
                                    relation={customContentsFiltered[0]}
                                    isSecured={isDisplaySecured}
                                    isSubsidized={isSubsidizedDisplay}
                                    subsidizeSlot={
                                      !editCampaignActive ? (
                                        user &&
                                        (hasAccessRole(user.roles, [
                                          UserRoleEnum.superAdmin,
                                          UserRoleEnum.superModeratorAgency
                                        ]) ||
                                          allDisplaysAreOwn) ? (
                                          <div style={{ marginBottom: 5 }}>
                                            <SubsidizeButton
                                              tooltip={t(
                                                programmatic === 'programmatic'
                                                  ? 'Subsidize display tooltip'
                                                  : 'Subsidize display traditional tooltip'
                                              )}
                                              checked={isSubsidizedDisplay}
                                              onClick={() =>
                                                updateSubsidizedPriceDisplay(
                                                  display.id,
                                                  !isSubsidizedDisplay
                                                )
                                              }
                                            />
                                          </div>
                                        ) : null
                                      ) : isSubsidizedDisplay ? (
                                        <SubsidizedStatusTag
                                          suspended={display.promised_shows == 0}
                                        />
                                      ) : null
                                    }
                                  />
                                </div>
                                {programmatic === 'programmatic' && (
                                  <div
                                    style={{
                                      textAlign: 'center',
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      width: '100%',
                                      gap: '10px'
                                    }}
                                  >
                                    <div
                                      className="content-info-relation content-info"
                                      style={{
                                        margin: 0,
                                        ...(domain === 'dv360' && {
                                          color: Colors.primaryAccent,
                                          background: Colors.extraLightPrimary
                                        })
                                      }}
                                    >
                                      {SeparateNumberFormat(totalImpressionsPerDayWithBonus)}{' '}
                                      {t('impressions/day')}
                                    </div>
                                  </div>
                                )}
                                {/* Spots version, kept in case playouts become relevant again:
                                {programmatic === 'programmatic' && (
                                  <div
                                    style={{
                                      textAlign: 'center',
                                      marginTop: '10px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      width: '100%',
                                      gap: '10px'
                                    }}
                                  >
                                    <div
                                      className="content-info-relation content-info"
                                      style={{
                                        margin: 0,
                                        color: Colors.primaryAccent,
                                        background: Colors.extraLightPrimary
                                      }}
                                    >
                                      {SeparateNumberFormat(totalSpotsPerDay)}{' '}
                                      <PlayoutsLabelContainer variant="perDay" />
                                    </div>
                                    {totalBonusSpotsPerDay > 0 && !isPaymentStatusApproved && (
                                      <div
                                        className="content-info-relation content-info"
                                        style={{
                                          backgroundColor: Colors.tintSuccess,
                                          color: '#52c41a',
                                          borderColor: '#52c41a',
                                          margin: '0'
                                        }}
                                      >
                                        + {SeparateNumberFormat(totalBonusSpotsPerDay)}
                                      </div>
                                    )}
                                  </div>
                                )}
                                */}
                                <div style={{ textAlign: 'center', marginTop: '15px' }}>
                                  {(creationType !== 'makeProposal' && !editCampaignActive) ||
                                    (editCampaignActive && (
                                      <Tooltip title={t('Add contents on the screen')}>
                                        <Button
                                          className="buttonActionsDisplayGroup"
                                          shape="circle"
                                          onClick={e => {
                                            handleModalUpdateContent(display);
                                          }}
                                        >
                                          <Icon type="plus" />
                                        </Button>
                                      </Tooltip>
                                    ))}
                                  {((editCampaignActive && currentCampaign.status != 'ready') ||
                                    !editCampaignActive) &&
                                    !isPaymentStatusApproved && (
                                      <Tooltip
                                        placement="top"
                                        title={
                                          displaysCollection.length < 2
                                            ? t(
                                                'To delete need at least two displays in the campaign'
                                              )
                                            : t('Remove screen')
                                        }
                                      >
                                        <Button
                                          shape="circle"
                                          className="buttonActionsDisplayGroup"
                                          disabled={group.displays.length < 2}
                                          onClick={() =>
                                            showModalDeleteRelation('deleteDisplay', display.id)
                                          }
                                        >
                                          <Icon type="close" />
                                        </Button>
                                      </Tooltip>
                                    )}
                                  {programmatic === 'programmatic' && !isPaymentStatusApproved && (
                                    <Tooltip
                                      placement="top"
                                      title={getTooltipForFixedBudget(
                                        'display',
                                        isFixedBudgetDisplay
                                      )}
                                    >
                                      <Button
                                        shape="circle"
                                        className="buttonActionsDisplayGroup"
                                        onClick={event => {
                                          fixedBudgetInDisplay([display], isFixedBudgetDisplay);
                                          stopPropagation(event);
                                        }}
                                      >
                                        {
                                          <i
                                            className={
                                              isFixedBudgetDisplay ? 'fa fa-lock' : 'fa fa-unlock'
                                            }
                                            aria-hidden="true"
                                            style={{
                                              color: 'gray',
                                              cursor: 'pointer',
                                              fontSize: 'large'
                                            }}
                                          ></i>
                                        }
                                      </Button>
                                    </Tooltip>
                                  )}
                                  <Tooltip
                                    title={
                                      !display.fill_screen
                                        ? t('Expand ad')
                                        : t('Return original resolution')
                                    }
                                  >
                                    <Button
                                      className="buttonActionsDisplayGroup"
                                      shape="circle"
                                      onClick={() => {
                                        displayToggleFillScreen(display);
                                      }}
                                    >
                                      {!display.fill_screen ? (
                                        <Icon type="fullscreen" />
                                      ) : (
                                        <Icon type="fullscreen-exit" />
                                      )}
                                    </Button>
                                  </Tooltip>
                                  <PendingContentButton
                                    editCampaignActive={editCampaignActive}
                                    currentCampaign={currentCampaign}
                                    creationType={creationType}
                                    user={user}
                                    onClick={() => displayTogglePendingContent(display)}
                                    isPendingContent={isPendingContentDisplay}
                                  />
                                  {editCampaignActive &&
                                  currentCampaign.payment_status !== 'pending' &&
                                  currentCampaign.status !== 'proposal' &&
                                  currentCampaign.payment_status !== 'cancelled' &&
                                  user &&
                                  (hasAccessRole(user.roles, [
                                    UserRoleEnum.superAdmin,
                                    UserRoleEnum.superModeratorAgency
                                  ]) ||
                                    allDisplaysAreOwn) ? (
                                    <Tooltip
                                      title={
                                        displayIsPaused(display)
                                          ? t('Resume Display')
                                          : t('Pause Display')
                                      }
                                    >
                                      <Button
                                        shape="circle"
                                        className="buttonActionsGroup"
                                        size="x-small"
                                        onClick={() =>
                                          handleIsPausedToggle(displayIsPaused(display), display)
                                        }
                                      >
                                        <Icon
                                          type={displayIsPaused(display) ? 'caret-right' : 'pause'}
                                        />
                                      </Button>
                                    </Tooltip>
                                  ) : null}
                                </div>
                                {programmatic === 'programmatic' && (
                                  <div
                                    style={{
                                      width: '100%',
                                      marginTop: '20px',
                                      marginBottom: '10px'
                                    }}
                                  >
                                    {displayMinimumProgrammaticPeriod === 0
                                      ? // FOR DAILY INVESTMENT
                                        totalSpotsPerDay < displayMinimumProgrammaticSpotsDaily &&
                                        !isPaymentStatusApproved && (
                                          <div>
                                            <Alert
                                              type="warning"
                                              className="defaultAlert"
                                              style={{ textAlign: 'center' }}
                                              description={
                                                <>
                                                  <Trans
                                                    i18nKey="minimum programmatic spots warning"
                                                    components={{ strong: <strong />, br: <br /> }}
                                                    values={{
                                                      minimumInvestmentDaily: `${usedCurrency} $${minimumInvestmentDaily.toFixed(
                                                        2
                                                      )}`
                                                    }}
                                                  />
                                                  <br />
                                                  <Text type="secondary">
                                                    {t('minimum investment breakdown', {
                                                      minimumInvestmentDaily: `${usedCurrency} $${minimumInvestmentDaily.toFixed(
                                                        2
                                                      )}`,
                                                      minimumInvestmentTotal: `${usedCurrency} $${minimumInvestmentTotal.toFixed(
                                                        2
                                                      )}`
                                                    })}
                                                  </Text>
                                                </>
                                              }
                                            />
                                          </div>
                                        )
                                      : //FOR TOTAL INVESTMENT
                                        totalSpots < minumumSpotsPeriod &&
                                        !isPaymentStatusApproved && (
                                          <div>
                                            <Alert
                                              type="warning"
                                              className="defaultAlert"
                                              style={{ textAlign: 'center' }}
                                              description={
                                                <Trans
                                                  i18nKey="minimum programmatic total investment warning"
                                                  components={{ strong: <strong />, br: <br /> }}
                                                  values={{
                                                    minimumInvestmentTotal: `${usedCurrency} $${minimumInvestmentTotal.toFixed(
                                                      2
                                                    )}`
                                                  }}
                                                />
                                              }
                                            />
                                          </div>
                                        )}
                                    {hasDiscounts && !isPaymentStatusApproved && (
                                      <DiscountProgressBar
                                        promiseShows={totalSpotsPerDay}
                                        totalSpots={totalPromisedShows}
                                        discounts={getDisplayDiscounts(display)}
                                        discountType={
                                          (getDisplayDiscounts(display)[0] || {}).discount_type ||
                                          'daily'
                                        }
                                        originalCpm={originalCpm}
                                        currency={usedCurrency}
                                        campaignDays={campaignDays}
                                      />
                                    )}
                                  </div>
                                )}
                              </div>
                            </Col>
                          </Row>
                          <Modal
                            title={t('Screen detail')}
                            visible={showScreenDetail && displayModalInfo.id === display.id}
                            onCancel={() => handleShowScreenDetail('close')}
                            footer={[
                              <Button key="back" onClick={() => handleShowScreenDetail('close')}>
                                OK
                              </Button>
                            ]}
                            width={modalWidth}
                            style={{ top: '10px' }}
                          >
                            <ScreenContainer
                              display={displayModalInfo}
                              screenDetail={showScreenDetail}
                              popup={true}
                              defaultTab={'info'}
                              editCart={true}
                              closeModal={() => handleShowScreenDetail('close')}
                            />
                          </Modal>
                          {displayModalUpdateContent &&
                            displayModalUpdateContent.id === display.id && (
                              <ScreenLibraryModalContainer
                                visible={!!displayModalUpdateContent}
                                groupName={display.name}
                                fromModal={'display'}
                                onCancel={() => handleModalUpdateContent(null)}
                                groupedDisplays={[displayModalUpdateContent]}
                                applyRelationOnScreens={applyRelationOnScreens}
                              />
                            )}
                        </div>
                      );
                    })}
                  </Panel>
                </Collapse>
                {selectGroupDisplayRules === group.key && (
                  <Modal
                    title={
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {t('Rules in group of displays')}
                        <HelpTooltipIcon
                          href="https://www.youtube.com/watch?v=VuoK7wMlcJc"
                          tooltip={
                            <Trans
                              i18nKey="Rules tooltip"
                              components={{
                                icon: <HelpIcon />
                              }}
                            />
                          }
                        />
                      </div>
                    }
                    visible={selectGroupDisplayRules == group.key}
                    footer={[
                      <Button key="ok" type="primary" onClick={() => showModalGroupDisplayRules()}>
                        {t('Close')}
                      </Button>
                    ]}
                    onCancel={() => showModalGroupDisplayRules()}
                    width={800}
                  >
                    <RulesContainer
                      key={group.key}
                      typeModal="groupDisplay"
                      typeName={group.key}
                      listContentDisplay={getContentDisplayByScreenGroup(group.displays)}
                    />
                  </Modal>
                )}
                {indexGroup === index && (
                  <ScreenLibraryModalContainer
                    visible={indexGroup === index}
                    groupName={group.key}
                    fromModal={'groupDisplays'}
                    onCancel={() => setIndexGroup(null)}
                    groupedDisplays={group.displays}
                    applyRelationOnScreens={applyRelationOnScreens}
                  />
                )}
              </Col>
            );
          })}
        {relationToDelete && (
          <Modal
            title={relationToDelete.title}
            visible={!!relationToDelete}
            onOk={() => removeRelationFromDisplayView(relationToDelete)}
            onCancel={() => showModalDeleteRelation()}
            okText={t('Remove')}
            cancelText={t('Cancel')}
          >
            <p style={{ margin: '20px' }}>{relationToDelete.description}</p>
          </Modal>
        )}
      </Row>
    </ScreensGroupHolder>
  );
};

export default ScreensGroupComponent;
